export const platformMixin = {
  computed: {
    isDev
      () {
      let domain = window.location.host
      return domain.includes('localhost')
    },
    hostname () {
      return window.location.host
    },
    isThaiCharoenPlus
      () {
      let domain = window.location.host

      return (domain.includes('xn--82ck2a4arhq4bxd0a3kwb') || domain.includes('thaicharoenplus'))
    },
    isSevenColor
      () {
      let domain = window.location.host

      return domain.includes('xn--7-pyfoob8d') || domain.includes('seven-color') 
    },
    isThaisiam
      () {
        let domain = window.location.host

        return domain.includes('xn--o3cuca3bxc5g')
    },
    isHuaypromt
      () {
        let domain = window.location.host

        return domain.includes('xn--v3cgbfrxs7t')
    },
    isJertjarat
      () {
        let domain = window.location.host

        return domain.includes('xn--82ca9a9c9a3br8g')
    },
    isLottoslot88
      () {
      let domain = window.location.host

      return domain.includes('lottoslot88')
    },
    isChokCharoen
      () {
      let domain = window.location.host

      return domain.includes('xn--42cieo3ioesdn')
    },
    isBooncharern
      () {
      let domain = window.location.host

      return domain.includes('xn--82cjb3c6b6fya9d')
    },
    isDefaultSite () {
      return !this.isThaiCharoenPlus && !this.isSevenColor && !this.isThaisiam && !this.isHuaypromt && !this.isJertjarat && !this.isLottoslot88 && !this.isChokCharoen && !this.isBooncharern
    }
  },
};